```vue
<template>
    <ServicePageLayout title="Электронные визитки и дизайн визитных карточек"
        description="Создаю современные электронные визитки и разрабатываю дизайн печатных визитных карточек стандартного размера 90×50 мм. Помогаю специалистам и бизнесу представить себя профессионально как в цифровом, так и в офлайн-формате."
        :includes="includes" :audience="audience" :steps="steps"
        price="Стоимость разработки — от 1 500 ₽. Сроки выполнения — от 2 рабочих дней." />
</template>

<script setup>
import ServicePageLayout from '@/components/cards/ServicePageLayout.vue';

const includes = [
    'разработка электронных визиток с индивидуальным оформлением',
    'создание дизайна печатных визитных карточек размером 90×50 мм',
    'подбор шрифтов, цветовой палитры и композиции',
    'размещение контактной информации и QR-кодов',
    'подготовка файлов для печати и цифрового использования',
];

const audience = [
    'самозанятым специалистам и фрилансерам',
    'экспертам и владельцам личного бренда',
    'малому и среднему бизнесу',
    'компаниям, которым необходим современный фирменный стиль',
];

const steps = [
    'обсуждение пожеланий и необходимой информации',
    'разработка одного или нескольких вариантов дизайна',
    'внесение согласованных правок',
    'подготовка итоговых файлов для печати и электронного использования',
];
</script>
```
